import 'mdn-polyfills/Object.assign';
import 'mdn-polyfills/Array.prototype.find';
import 'mdn-polyfills/Object.entries';
import 'mdn-polyfills/Node.prototype.remove';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.js';
import Error from './error.js';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

const homePageInPackageJson = {
	pre: 'https://devala.es/devs/telxius-2021/network/interactive-map',
	pro: 'https://telxius.com/network/interactive-map'
};

const basename = {
	pre: '/devs/telxius-2021/network/interactive-map',
	pro: ''
};

ReactDOM.render(
	<BrowserRouter basename={basename.pre}>
		<Switch>
			<Route path="/" exact render={(props) => <App {...props} type="none" />} />
			<Route path="/cable/:id" exact render={(props) => <App {...props} type="cable" />} />
			<Route path="/:layer/:type/:id" exact render={(props) => <App {...props} />} />
			<Route path="/:type/:id" exact render={(props) => <App {...props} />} />
			<Route path="/:layer" exact render={(props) => <App {...props} />} />
			<Route render={(props) => <Redirect to="/" />} />
		</Switch>
	</BrowserRouter>,

	document.getElementById('root')
);
registerServiceWorker();
